import { useTranslation } from 'react-i18next';

const About = () => {
  const { t } = useTranslation();

  const stats = [
    { icon: 'ri-global-line', label: 'International', value: 'Operations' },
    { icon: 'ri-shield-check-line', label: 'Trusted', value: 'Corporate' },
    { icon: 'ri-links-line', label: 'Cambodia', value: 'Japan' },
    { icon: 'ri-building-4-line', label: 'Multi-Business', value: 'Capability' },
  ];

  return (
    <section id="about" className="bg-white py-20 md:py-28" aria-labelledby="about-heading">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-5xl mx-auto">
        <div className="text-center mb-12 md:mb-20">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="w-8 h-px bg-gold-400" aria-hidden="true"></span>
            <p className="text-gold-500 text-xs md:text-sm font-semibold tracking-[0.25em] uppercase">
              {t('about_label')}
            </p>
            <span className="w-8 h-px bg-gold-400" aria-hidden="true"></span>
          </div>
          <h2 id="about-heading" className="text-2xl md:text-4xl lg:text-[2.75rem] font-bold text-navy-900 leading-tight">
            {t('about_title')}
          </h2>
        </div>

        <div className="max-w-3xl mx-auto text-center mb-12 md:mb-16">
          <p className="text-sm md:text-base text-gray-600 leading-[1.8]">
            <strong className="text-navy-800">{t('about_desc')}</strong>
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {stats.map((item) => (
            <div
              key={item.label}
              className="bg-navy-50 rounded-sm p-6 md:p-8 text-center hover:bg-navy-100 transition-colors duration-300 group"
            >
              <div className="flex items-center justify-center w-12 h-12 md:w-14 md:h-14 mx-auto mb-4 rounded-full bg-white border border-gold-200/60 group-hover:border-gold-300 transition-colors duration-300">
                <i className={`${item.icon} text-xl md:text-2xl text-gold-500`}></i>
              </div>
              <p className="text-xs md:text-sm font-medium text-gray-500 mb-0.5">{item.label}</p>
              <p className="text-sm md:text-base font-semibold text-navy-800">{item.value}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
